import React from 'react'
import Purchases from './index'
import CreatePurchase from './createPurchase'

export const paths = [
    {
        path: "/Purchases",
        component: Purchases,
    },
    {
        path: "/purchases/create",
        component: CreatePurchase
    }
]

export const PurchasesRouters = {
    icon: "shopping-cart",
    path: "/purchases",
    label: 'Compras',
    badge: "beta",
    tree: [
        {
            icon: 'shopping-bag',
            testId: '',
            path: '/purchases/',
            label: "Visualizar compras"
        },
        {
            icon: 'plus',
            testId: '',
            path: '/purchases/create',
            label: "Cadastrar compra"
        },
    ]
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/routers.js